import { render } from "./SearchCardV2.vue?vue&type=template&id=154573f6"
import script from "./SearchCardV2.vue?vue&type=script&lang=js"
export * from "./SearchCardV2.vue?vue&type=script&lang=js"

import exportComponent from "/opt/approot/build.20261030-093834-708061d9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__